<template>
<div>
  <div >
    <b-card
        border-variant="secondary"
        header-bg-variant="secondary"
        header-text-variant="white"
        :header="getCardHeader"
        :title= "getTitle"
        align="center"
        class="mx-auto"
        style="max-width: 40rem;"
    >
      <b-form @submit="applyChange">
        <b-form-input v-if="changeRequested === 'hostname'"
                      id="device-input-hostname"
                      required
                      v-model="deviceResource.hostname"
                      :placeholder="$t('device.namePlaceholder')"
        ></b-form-input>
        <b-button type="submit" class="m-2" variant="outline-primary">{{$t('buttonDefaults.change')}}</b-button>
        <b-button @click="onCancel" class="m-2" variant="outline-primary" >{{ $t("buttonDefaults.cancel")}}</b-button>
      </b-form>
    </b-card>
  </div>
</div>
</template>

<script>
import router from "@/router";
import store from "@/store/store";
import identityDevicesApi from "@/services/identityDevicesApi";
import devicesApi from "@/services/devicesApi";
import userApiService from "@/services/userApiService";
export default {
  name: "ChangeDeviceDetails",
  props: {
    device: { type: String },
    changeRequested: {type: String}
  },
  data() {
    console.log("Change Device Details")
    return {
      text: '',
      deviceResource: {
        guid: '',
        type: '',
        hostname: '',
        description	: "",
        macAddress: ""
      }
    }
  },
  mounted() {
    if(this.device !== undefined) {
      this.deviceResource.guid = this.device.guid;
      this.deviceResource.type = this.device.type;
      this.deviceResource.hostname = this.device.hostname;
      this.deviceResource.description = this.device.description;
      this.deviceResource.macAddress = this.device.macAddress;
    }
  },
  computed: {
    getTitle() {
      if (this.changeRequested === "hostname") {
        return this.$t('device.hostname')
      } else {
        return this.$t('device.description')
      }
    },
    getCardHeader() {
      if(this.deviceResource.type === 'UNIT') {
        return (this.$t('device.changePrefix') + this.$t('device.unitDeviceHeader'))
      } else if(this.deviceResource.type === 'GUEST') {
        return (this.$t('device.changePrefix') +  this.$t('device.guestDeviceHeader'))
      } else {
        return (this.$t('device.changePrefix') + this.$t('device.identityDeviceHeader'))
      }
    }
  },
  methods: {
    async applyChange(evt) {
      console.log("Updating device", this.deviceResource);
      evt.preventDefault()
      try {
        if(this.changeRequested === 'hostname') {
          if(this.deviceResource.type === 'LINKED') {
            await identityDevicesApi.updateDevice(store.getters.getSelectedUserId, this.deviceResource.guid, this.deviceResource)
          } else {
            await devicesApi.updateDevice(this.deviceResource.guid, this.deviceResource)
          }
        }

        var updatedDevice = undefined;
        if(this.deviceResource.type === 'LINKED') {
          const result = await userApiService.getAllUserDevices(store.getters.getSelectedUserId)
          updatedDevice = result.contents.find(device => device.guid === this.deviceResource.guid)
        } else {
          const result = await devicesApi.getDevices(this.deviceResource.type)
          updatedDevice = result.contents.find(device => device.guid === this.deviceResource.guid)
        }

        if(updatedDevice && updatedDevice.lastUpdatedTime != null) {
            updatedDevice.lastUpdatedTime = new Date(updatedDevice.lastUpdatedTime).toLocaleString()
        }
        router.push({ name: 'Device', params: {deviceItem: updatedDevice ?? this.device, updated: true}})
      } catch(e) {
        console.log("Error Updating Device:", e)
        router.push({ name: 'Device', params: {deviceItem: this.device, errorUpdating: true}})
      }

    },
    onCancel() {
      router.push({ name: 'Device', params: {deviceItem: this.device}})
    }
  }
}
</script>

<style scoped>

</style>